export const SWITCH_ACCOUNT_VALUE = 'switch-account';
